import React from "react";

function Tile({ className, value, onClick, playerTurn }) {
  let tileValueClass = null;
  if (value === "X") {
    tileValueClass = "tile-x"; 
  } else if (value === "O") {
    tileValueClass = "tile-o";
  }

  let hoverClass = null;
  if (value === null && playerTurn != null) {
    hoverClass = `${playerTurn.toLowerCase()}-hover`;
  }

  return (
    <div className={`tile ${className} ${hoverClass}`} onClick={onClick}>
      <span className={tileValueClass}>{value}</span>
    </div>
  );
}

export default Tile;
